import NotLoggedInCard from "@/components/molecules/not-logged-in-card";
import CartProductRecommendation from "@/components/organisms/cart-product-recommendation";
import CartProducts from "@/components/organisms/cart-products";
import CartSidebar from "@/components/organisms/cart-sidebar";
import StageHeader from "@/components/organisms/stage-header";
import { __ } from "@/lib/i18n/functions";
import { getSiteSettings } from "@/lib/prismic";

type CartProps = {
  resolution: Resolution;
};

const Cart = async ({ resolution }: CartProps) => {
  const { locale } = resolution;

  const { notifications } = await getSiteSettings(locale);

  return (
    <>
      <StageHeader
        description={[
          {
            type: "paragraph",
            text: `${__("Trust Festi Rent for your parties and events.", locale)}`,
            spans: [],
          },
          {
            type: "paragraph",
            text: `${__("We are happy to advise you on choosing the equipment that will suit you perfectly.", locale)}`,
            spans: [],
          },
        ]}
        locale={resolution.locale}
        className="md:my-4"
        orientationOnMobile="left"
        title={__("Cart", locale)}
      />
      <div className="bg-[#FBF9F899]">
        <div className="container flex flex-col gap-4 px-3.5 sm:gap-8 md:gap-12.5 md:p-7.5 xl:flex-row">
          <article className="flex-3/5 space-y-[13px]">
            <NotLoggedInCard locale={locale} />
            <CartProducts locale={locale} notifications={notifications} />
          </article>
          <CartSidebar locale={locale} />
        </div>
      </div>
      <CartProductRecommendation locale={locale} />
    </>
  );
};

export default Cart;
